import React from 'react'
import './Dropdown.css';
import { FaPlus, FaMinus } from 'react-icons/fa';

const DropdownHeader = ({onClick, btnTxt, open, isLong}) => {
  return (
    <button className='drop_down_header' onClick={onClick}>
      <h3 className={isLong ? 'drop_down_txt long' : 'drop_down_txt'}>{btnTxt}</h3>
      <span className='drop_down_txt' style={{pointerEvents: 'none'}}>{open ? <FaMinus/> : <FaPlus/>}</span>
    </button>
  )
}

export default DropdownHeader